const TOHU_CHATBOT_CONFIG = {
  id: 'bot-id-AxwRXFrM8cDLufSR',
  src: 'https://portal.faqbot.nz/api/v1/scripts/AxwRXFrM8cDLufSR/corejs'
}

export default TOHU_CHATBOT_CONFIG
